let storeRef;

const setStore = (store) => {
  storeRef = store;
};

const getStore = () => storeRef;

export { setStore, getStore };
